<template>
  <div>
    <div class="bg-surface-default-mid py-24 md:py-32 pb-72 md:pb-96">
      <RevContainer>
        <HeroSection
          class="mb-32"
          @calculate-savings-click="scrollTo(savingsSection)"
          @explore-plans-click="scrollTo(plansSection)"
          @faq-click="scrollTo(faqSection)"
        />

        <FeatureHighlights class="mb-56" />

        <div ref="plansSection" class="space-y-8">
          <h2 class="heading-1">
            {{ i18n(translations.title) }}
          </h2>

          <p class="body-1 text-static-default-low">
            {{ i18n(translations.subtitle) }}
          </p>
        </div>

        <div class="mt-24 grid grid-cols-1 gap-16 md:grid-cols-3">
          <VisibleByVerizonOfferCard />
          <USMobileOfferCard />
          <NobleMobileOfferCard />
        </div>

        <div class="mt-24 flex justify-center">
          <RevLink
            :tracking="{
              zone: 'telco_comparison_cards',
              name: 'us_telco_comparison_table',
            }"
            @click="openModal(PLAN_COMPARISON_DRAWER)"
          >
            {{ i18n(translations.seePlanComparison) }}
          </RevLink>
        </div>
      </RevContainer>
    </div>

    <div ref="savingsSection">
      <SavingsComparisonSection />
    </div>

    <RevContainer class="py-32 md:py-48">
      <ReviewsCarousel />
    </RevContainer>

    <div ref="faqSection">
      <FaqSection />
    </div>

    <PlanComparisonDrawer />
  </div>
</template>

<script setup lang="ts">
import { useHead } from '#imports'
import { ref } from 'vue'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevContainer } from '@ds/components/Container'
import { RevLink } from '@ds/components/Link'
import { openModal } from '@ds/components/ModalBase'

import translations from './UsTelcoComparatorsLandingPage.translations'
import FaqSection from './components/FaqSection/FaqSection.vue'
import FeatureHighlights from './components/FeatureHighlights/FeatureHighlights.vue'
import HeroSection from './components/HeroSection/HeroSection.vue'
import NobleMobileOfferCard from './components/NobleMobileOfferCard/NobleMobileOfferCard.vue'
import PlanComparisonDrawer from './components/PlanComparisonDrawer/PlanComparisonDrawer.vue'
import { PLAN_COMPARISON_DRAWER } from './components/PlanComparisonDrawer/constants'
import ReviewsCarousel from './components/ReviewsCarousel/ReviewsCarousel.vue'
import SavingsComparisonSection from './components/SavingsComparisonSection/SavingsComparisonSection.vue'
import USMobileOfferCard from './components/USMobileOfferCard/USMobileOfferCard.vue'
import VisibleByVerizonOfferCard from './components/VisibleByVerizonOfferCard/VisibleByVerizonOfferCard.vue'

const i18n = useI18n()

const plansSection = ref<HTMLElement | null>(null)
const savingsSection = ref<HTMLElement | null>(null)
const faqSection = ref<HTMLElement | null>(null)

function scrollTo(target: HTMLElement | null) {
  target?.scrollIntoView({ behavior: 'smooth', block: 'start' })
}

useHead({
  title: i18n(translations.metaTitle),
})
</script>
